// extracted by mini-css-extract-plugin
module.exports = {"loading":"RequestResponseTab_loading__2xHw_","root":"RequestResponseTab_root__YQGwR"};